import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { DOCTOR } from "@/data";

export const FloatingActions = () => (
  <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-actions">
    <motion.a
      href={`https://wa.me/${DOCTOR.phoneIntl}`}
      target="_blank"
      rel="noreferrer"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ y: -3 }}
      className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-[#25D366]/40"
      aria-label="WhatsApp"
      data-testid="fab-whatsapp"
    >
      <MessageCircle size={24} />
    </motion.a>
    <motion.a
      href={`tel:+${DOCTOR.phoneIntl}`}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ y: -3 }}
      className="w-14 h-14 rounded-full bg-[#B9735A] text-white flex items-center justify-center shadow-lg shadow-[#B9735A]/40"
      aria-label="Call"
      data-testid="fab-call"
    >
      <Phone size={22} />
    </motion.a>
  </div>
);
